import { render, staticRenderFns } from "./ChatNavButton.vue?vue&type=template&id=b1ab66b2&scoped=true&"
import script from "./ChatNavButton.vue?vue&type=script&lang=js&"
export * from "./ChatNavButton.vue?vue&type=script&lang=js&"
import style0 from "./ChatNavButton.vue?vue&type=style&index=0&id=b1ab66b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1ab66b2",
  null
  
)

export default component.exports